import { Link, useLocation } from 'react-router-dom';
import { CalendarDays } from 'lucide-react';
import { isInternalPath } from './ExitIntentModal';
import { useCurrentPortalPaused } from '../../lib/maintenance';

/**
 * Site-wide floating Book now CTA (mobile, tablet, desktop).
 * Hidden on staff/admin portals and on the checkout screen so it does not cover the form.
 */
export default function FloatingBookNow() {
  const { pathname } = useLocation();
  const paused = useCurrentPortalPaused();
  if (paused) return null;
  if (isInternalPath(pathname)) return null;
  if (pathname === '/booking' || pathname.startsWith('/booking/')) return null;
  if (pathname === '/login' || pathname === '/signup' || pathname === '/register' || pathname === '/onboarding') return null;
  if (pathname === '/vaccination-catalogue' || pathname === '/vaccination') return null;

  return (
    <div
      data-testid="floating-book-now"
      className="fixed left-0 right-0 bottom-0 z-50 pointer-events-none px-4 pb-4 md:left-auto md:right-6 md:bottom-6 md:w-auto md:px-0 md:pb-0"
    >
      <Link
        to="/vaccination-catalogue"
        data-testid="msa-request"
        className="pointer-events-auto flex items-center justify-center gap-2 w-full md:w-auto bg-[#f37721] hover:bg-[#d9651a] text-white rounded-full py-3.5 md:py-3 px-6 shadow-[0_18px_40px_-12px_rgba(243,119,33,0.55)] font-semibold text-base md:text-sm"
        style={{ fontFamily: 'Montserrat, sans-serif' }}
      >
        <CalendarDays className="w-5 h-5" />
        Book now
      </Link>
    </div>
  );
}
